module.exports = __webpack_public_path__ + "img/land.c830da7e.jpg";